import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";

interface TabItem {
  label: string;
  value: string;
}
export const useAnalysisControllers = () => {
  const tabsData: TabItem[] = [
    { label: "Chart", value: "chart" },
    { label: "Recent Transaction Table", value: "table" },
  ];
  const [filter, setFilter] = React.useState({
    search: "",
    status: "",
    transactionType: "",
    paymentMethod: "",
  });

  const [activeTab, setActiveTab] = useState(tabsData[0].value);
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");

  React.useEffect(() => {
    if (tabParam && tabParam !== activeTab) {
      setActiveTab(tabParam);
    }
  }, [tabParam, activeTab]);

  const handleTabChange = (tabValue: string) => {
    setActiveTab(tabValue);
    setSearchParams({ tab: tabValue });
  };

  const handleFilterChange = (key: keyof typeof filter, value: string) => {
    setFilter((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return {
    // state
    activeTab,
    filter,

    // data,
    tabsData,

    // function
    handleTabChange,
    handleFilterChange,
  };
};
